import { SafeUrl } from "@angular/platform-browser";

export class QRCodeSettings {
  public sessionId: string;
  public safeHtmlUrl?: SafeUrl;
  public safePreviewHtmlUrl?: SafeUrl;
  public background?: string;
}
